import React, { useState } from "react";

function Contact() {
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("sending");

    const form = e.target;
    const data = new FormData(form);

    try {
      const res = await fetch("https://formspree.io/f/xkooywqz", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  }

  return (
    <section id="contact" className="py-16 px-8">
      {/* Título */}
      <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
        Contacto
      </h2>

      {/* Texto Adicional */}
      <div className="max-w-4xl mx-auto text-center text-gray-700 space-y-4 mb-8">
        <p className="text-xl font-bold">VEM CONHECER-NOS</p>
        <p className="text-justify">
          Pretende realizar uma aula experimental? Preencha o formulário com os
          seus dados para que possamos entrar em contacto consigo.
        </p>
        <p className="font-bold text-justify">Encontramo-nos no MIND!</p>
      </div>

      {/* Formulário */}
      <form className="max-w-4xl mx-auto space-y-4" onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Nome */}
          <input
            type="text"
            name="name"
            placeholder="Primeiro e Último Nome"
            className="border p-3 rounded w-full text-justify"
            required
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="E-mail"
            className="border p-3 rounded w-full text-justify"
            required
          />

          {/* Telemóvel */}
          <input
            type="text"
            name="phone"
            placeholder="Telemóvel"
            className="border p-3 rounded w-full text-justify"
            required
          />

          {/* Serviço Pretendido */}
          <select
            name="service"
            className="border p-3 rounded w-full text-justify"
            required
            defaultValue=""
          >
            <option value="" disabled>
              Serviço Pretendido
            </option>
            <option value="Personal Training">Personal Training</option>
            <option value="Treino Online">Treino Online</option>
            <option value="Treino ao Domicílio">Treino ao Domicílio</option>
          </select>
        </div>

        {/* Mensagem */}
        <textarea
          name="message"
          placeholder="Mensagem (opcional)"
          className="border p-3 rounded w-full text-justify"
          rows={4}
        />

        {/* Botão */}
        <button
          type="submit"
          disabled={status === "sending"}
          className={`px-6 py-3 rounded shadow-md transition duration-300 ${
            status === "sending"
              ? "bg-gray-400 text-white cursor-not-allowed"
              : "bg-[#012326] text-white hover:bg-[#01474c]"
          }`}
        >
          {status === "sending" ? "A enviar..." : "Enviar"}
        </button>

        {/* Feedback ao utilizador */}
        {status === "success" && (
          <p className="text-green-600 font-semibold">
            ✅ Mensagem enviada com sucesso! Vamos entrar em contacto consigo.
          </p>
        )}

        {status === "error" && (
          <p className="text-red-600 font-semibold">
            ❌ Ocorreu um erro ao enviar. Tente novamente ou contacte-nos pelas redes sociais.
          </p>
        )}
      </form>
    </section>
  );
}

export default Contact;
